module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "header-center"
  }, [(!_vm.previousMonthDisabled()) ? _c('span', {
    staticClass: "prev-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPrev.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "month-arrow",
    attrs: {
      "src": require("../../../assets/images/icons/arrow-left.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title) + " " + _vm._s(_vm.year))]), _vm._v(" "), (!_vm.nextMonthDisabled()) ? _c('span', {
    staticClass: "next-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goNext.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "month-arrow -right",
    attrs: {
      "src": require("../../../assets/images/icons/arrow-left.png")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._t("header-right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1ab8cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/vue-calendar/calendar-header.vue
// module id = 1198
// module chunks = 0